/** 推送模板的运营名称；模板管理与只读分析共用，未知历史模板保留原 code。 */
/**
 * template_slug → 页面展示中文类型名（#104：模板从 task_type 改 template_slug 键）。
 * **不写死条数**（ADM-PUSH-S001）：列表按后端返回的实际行数渲染，本表只管中文名。
 * 未命中回退原 slug（前端兼容未来新增）。名称不参与统计分组或查询。
 */
const PUSH_TEMPLATE_LABELS: Record<string, string> = {
  // 订阅开通 / 续费各两个文案变体（按本期 本期实发 BONUS 是否 > 0 分流），运营两条文案各自维护
  subscription_started: '订阅开通通知',
  subscription_started_with_bonus: '订阅开通通知（含赠币）',
  subscription_renewed: '续费成功',
  subscription_renewed_with_bonus: '续费成功（含赠币）',
  // 同一业务事件的两个文案变体（按本笔 payment_settlements.bonus_amount 是否 > 0 分流），
  // 运营两条文案各自维护，故各占一行
  payment_settled: '权益到账通知',
  payment_settled_with_bonus: '权益到账通知（含赠币）',
  reading_pass_card_settled: '阅读卡到账通知',
  reading_pass_free_trial_claim_remind: '免费体验卡领取提醒',
  reading_pass_free_trial_activate_remind: '免费体验卡激活提醒',
  chapter_update: '连载更新',
  novel_delisted: '书籍下架',
  feedback_reply: '客服回复',
  admin_user_notice: '单用户服务通知',
  signin_remind: '签到提醒',
  user_recall: '用户召回',
  novel_recommend: '书籍推荐',
  topup_promo: '充值活动',
  // 已移出注册表的历史 slug：只读分析里的历史消息仍按中文名展示，模板维护页不再出现
  subscription_renewal_remind: '续费提醒（已停用）',
};

/** 名称只用于运营展示；查询与历史分组仍使用原始 slug。 */
export function formatPushTemplateName(templateSlug: string): string {
  return Object.hasOwn(PUSH_TEMPLATE_LABELS, templateSlug)
    ? (PUSH_TEMPLATE_LABELS[templateSlug] ?? templateSlug)
    : templateSlug;
}
